import React from "react"
import Header from "./Header"
import Footer from "./Footer"
import CookieBanner from "./CookieBanner"

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <main style={{ paddingTop: "var(--header-height)" }}>{children}</main>
      <Footer />
      <CookieBanner />
    </>
  )
}

export default Layout
